import { Container } from "lucide-react";
import { createLucideIcon } from "./createLucideIcon";

export const ContainerIcon = createLucideIcon(Container);
